export default class Image {
    static handle(
        host,
        name,
        w = null,
        h = null,
        fetchOrigin = false,
    ) {
        let link
        let pathName

        if (fetchOrigin === true) {
            pathName = "io";
        } else {
            pathName = "i";
        }

        if (w && h === null) {
            link = host + '/' + pathName + '/w' + w + '/' + name
        } else if (w === null && h) {
            link = host + '/' + pathName + '/h' + h + '/' + name
        } else if (w && h) {
            link = host + '/' + pathName + '/' + w + 'x' + h + '/' + name
        } else {
            link = host + '/' + pathName + '/' + name
        }

        return link
    }
}
